import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { 
  FETCH_ACTUAL_BOOKINGS,
  FETCH_TEMPORY_BOOKINGS,
  CREATE_CONSULTATION
} from "constants/new.consultaion.constants";
import axios from "axios";
import {  
  getActualBookingsSuccess,
  getTemporyBookingsSuccess,
  createConsultationSuccess,
} from "actions/new.consultaion.action";
import { getSessions } from "actions/schedular.action";
import { showErrors, stopLoader, setNotification } from "actions/general.action";

// get actual bookings
const fetchActualBookingRequest = async () => {
  let link = "/api/v1/super_admin/consultations?status=1";
  return axios.get(link); 
};
// get teporary bookings
const fetchTemporyBookingRequest = async () => {
  let link = "/api/v1/super_admin/consultations?status=0";
  return axios.get(link); 
};

const getBookingQuotesFromGen2 = async (payload) => {

  const data_object = {
    isArray: false,
    data: {
      consultantId: "dr_" + payload.doctor_id, 
      customerId : "pa_" + payload.patient_id
    },
  };

  return axios.post(
    process.env.REACT_APP_GEN2_BACKEND_HOST + '/pricing/v1/bookingQuotes', 
    data_object, 
    {
      headers: {
        Authorization: "Bearer " + process.env.REACT_APP_GEN2_SECRET_KEY
      },
    }
  );
}

const createConsultationRequest = async (payload) => {
  let fd = new FormData();
  fd.append('doctor_id', payload.doctor_id);
  fd.append('patient_id', payload.patient_id);
  fd.append('session_start_time', payload.session_start_time);
  fd.append('session_end_time', payload.session_end_time);
  fd.append('estimate_consult_time', payload.estimate_consult_time);
  fd.append('estimate_consult_no', payload.estimate_consult_no);
  fd.append('display_cost', payload.display_cost);
  fd.append('description', payload.description);
  fd.append('notes', payload.notes);
  fd.append('quote', JSON.stringify(payload.quote))
  fd.append('estimated_by', payload.estimated_by)

  return axios.post("api/v1/super_admin/consultations", fd);
}

function* fetchActualBookings() {
  try {
    const result = yield call(fetchActualBookingRequest);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(getActualBookingsSuccess (result.data.data));
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

function* fetchTemporyBookings() {
  try {
    const result = yield call(fetchTemporyBookingRequest);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(getTemporyBookingsSuccess (result.data.data));
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

function* createConsultation({ payload }) {
  let notification = {
    open: true,
    status: "",
    message: "",
  };

  try {
    // get booking quotes
    const quoteResult = yield call(getBookingQuotesFromGen2, payload)

    if (quoteResult.error) {
      notification.status = "error";
      notification.message = "Request Failed";
      yield put(stopLoader());
    } else {

      if (quoteResult.data && Object.keys(quoteResult.data.data).length > 0) {
        if (quoteResult.data.data.quote === undefined) {
          notification.status = "error";
          notification.message = "No quote for this session for patient. This happens when the patient and doctor don't share any domains";
          yield put(stopLoader());
  
        } else if (quoteResult.data.data.quote.values.total.value != 0) { 
            notification.status = "error";
            notification.message = "Non-zero quote for patient. This happens when the patient isn't on any free domains with the doctor they're trying to book.";
            yield put(stopLoader());
  
        } else {
          // create consultation
          const {
            customerId,
            consultantId,
            renderItems,
            values
          } = quoteResult.data.data.quote;
  
          payload = {
            ...payload,
            quote: {
              customerId,
              consultantId,
              renderItems,
              values
            }
          }
  
          const result = yield call(createConsultationRequest, payload);
        
          if (result.message) {
            notification.status = "error";
            notification.message = "Request Failed";
            yield put(stopLoader());
          } else {
            notification.status = "success";
            notification.message = "Consultation created";
            yield all([
              put(createConsultationSuccess(result.data)),
              put(getSessions({
                type: payload.type,
                doctor_id: payload.doctor_id
              }))
            ])
          }
       }
      } else {
        notification.status = "error";
        notification.message = "Data not found for this doctor and patient";
        yield put(stopLoader());
      }
    }
    
    yield put(setNotification(notification));
  } catch (error) {
    notification.status = "error";
    notification.message = (error.response.data) ? error.response.data.message : error.message;

    yield put(stopLoader());
    yield put(setNotification(notification));
  }
}

export function* forkfetchActualBookings() {
  yield takeEvery(FETCH_ACTUAL_BOOKINGS, fetchActualBookings);
}

export function* forkfetchTemporyBookings() {
  yield takeEvery(FETCH_TEMPORY_BOOKINGS, fetchTemporyBookings);
}

export function* forkCreateConsultation() {
  yield takeEvery(CREATE_CONSULTATION, createConsultation);
}

export default function* rootSaga() {
  yield all([
    fork(forkfetchActualBookings),
    fork(forkfetchTemporyBookings),
    fork(forkCreateConsultation),
  ]);
}